const ChembioHivThemeVariables: Record<string, any> = {
  manufacturer: 'Chembio Diagnostics Brazil Ltda',
  pageTitle: 'WebApp - Autoteste HIV-1/2 Sure Check',
  titleColor: '#262626',
  textColor: '#4d4d4d',
  backgroundBase: '#186DB5',
  backgroundBaseFilter:
    'invert(28%) sepia(7%) saturate(16%) hue-rotate(31deg) brightness(94%) contrast(84%)',
  backgroundBaseGradient: '#3cf43e',
  backgroundDaxQRCode: 'linear-gradient(198.31deg, #28629E, #73A6D1, #28629E)',
  ResultShareModal: '#186DB5',
  ResultShareModalTitle: '#FFFF',
  backgroundShareResult: '#F7FCFA',
  backgroundLoaderResult:
    'linear-gradient(198.31deg, rgba(132, 177, 216, 0.7) 1.55%, rgba(34, 56, 104, 0.7) 77.92%, rgba(132, 177, 216, 0.7) 100%), #186DB5',
  backgroundLoaderAnimationStepA:
    'linear-gradient(198.31deg, rgba(132, 177, 216, 0.7) 1.55%, rgba(34, 56, 104, 0.7) 77.92%, rgba(132, 177, 216, 0.7) 100%), #186DB5',
  backgroundLoaderAnimationStepB:
    'linear-gradient(198.31deg, rgba(132, 177, 216, 0.7) 1.55%, rgba(34, 56, 104, 0.7) 77.92%, rgba(132, 177, 216, 0.7) 100%), #186DB5',
  backgroundLoaderAnimationStepC:
    'linear-gradient(198.31deg, rgba(132, 177, 216, 0.7) 1.55%, rgba(34, 56, 104, 0.7) 77.92%, rgba(132, 177, 216, 0.7) 100%), #186DB5',
  backgroundLoaderBar:
    'linear-gradient(90deg, #223868 0%, rgba(132, 152, 216, 0.35) 100%)',
  backgroundShareScreen: '#F7FCFA',
  backgroundPlayerResult: '#D9E9E2',
  backgroundStrongBase: '#BAB7B5',
  urlTest:
    'https://ecodiagnostica.com.br/diagnostico-rapido/autoteste-covid-ag-detect/',
  urlPathLoaderFile: 'chembio/loader-logo.png',
  urlPathLogoFile: 'chembio/logo.png',
  urlFavicon: 'chembio/favicon.png',
  logoWidth: '220px',
  logoHeight: '42px',
  urlPathLogoFileWhiteHeader: 'chembio/chembio-logo.png',
  urlPathLogoFileWhite: 'chembio/chembio-logo.png',
  urlPathLogoResult: 'chembio/logo.png',
  urlPathLogoFileCrx: 'clinicarx-logo-green.svg',
  logoWidthWhite: '121px',
  logoHeightWhite: '30px',
  logoWidthResult: '119px',
  logoHeightResult: '23px',
  logoWhiteTopMargin: '20px',
  logoWidthWhiteDask: '166px',
  logoHeightWhiteDask: '80px',
  testName: 'Autoteste HIV-1/2 Sure Check',
  urlPathTestImage: 'chembio/hiv-sure-check.png',
  urlPathDocumentIcon: 'eco/card-result.png',
  urlVideoGuidelines: 'https://www.youtube.com/embed/eJ16atMWwoc',
  urlPathQRCode: 'chembio/qrcode_chembio_hiv.png',
  socialShareInfo:
    'Acabei de gerar o cartão de resultado do meu Autoteste HIV-1/2 Sure Check.',
  totalSteps: 7,
  testStepOneContents: {
    title: 'Preparar o autoteste',
    steps:
      '<ol> <li>Pegue o suporte do teste e coloque em uma superfície plana com a base maior para baixo.</li><li>Abra o sachê do teste e pegue o dispositivo.</li>  <li>Retire a cápsula do tampão do dispositivo e insira no suporte com o lacre para cima.</li><li>Abra o álcool e o use para limpar o dedo. Espere secar.</li></ol>',
    image: 'chembio/passo1.gif',
    warningActive: false,
    warningText: '',
  },
  testStepTwoContents: {
    title: 'Coletar amostra',
    steps:
      '<ol><li>Retire a tampa da lanceta (dispositivo com ponta perfuradora) e encoste a parte vermelha no dedo limpo.</li><li>Pressione firmemente para perfurar a pele. </li><li>Aperte o dedo até formar uma gota de sangue.</li><li>Preencha a ponta do dispositivo de teste com o sangue.</li></ol>',
    image: 'chembio/passo2.gif',
    warningActive: false,
    warningText: '',
  },
  testStepThreeContents: {
    title: 'Fazer o teste',
    steps:
      '<ol><li>Posicione o dispositivo verticalmente acima do suporte do teste.</li><li>Empurre firmemente através do lacre até o fundo. Você sentirá 3 clicks.</li><li>Veja se há fluxo de cor rosa no dispositivo.</li><li>Abra a gase estéril para limpar o dedo e coloque o curativo.</li></ol>',
    image: 'chembio/passo3.gif',
    correctPositionImage: 'chembio/correct-position.png',
    modalAwaitTime: true,
    warningBeforeImageActive: true,
    warningActive: false,
    warningText: `Se o fluxo rosa não aparecer em até 1 minuto, empurre o dispositivo de teste mais fundo na cápsula. <span id="modalLink" style="color: #006ba6; text-decoration: underline;">Clique aqui para verificar a posição correta do dispositivo.</span> `,
  },
  testStepFourContents: {
    title: 'Responder o questionário',
    warningText: `As respostas não serão de forma alguma vinculadas à sua
    identidade, CPF ou demais formas de identificação, mantendo
    sigilo.`,
  },
  testStepFiveContents: {
    title: 'Informe o resultado',
    warningText: `A intensidade da cor das linhas no dispositivo podem variar e
    mesmo os tons mais claros devem ser considerados.`,
  },
  testStepSixContents: {
    title: 'Informar dados para o cartão de resultados',
    warningText: ` O preechimento é voluntário. Você poderá seguir sem informar,
    porém, seu cartão de resultados ficará sem identificação.`,
  },
  logoViewResultCardHeight: '25px',
  logoViewResultCardWidth: '132px',
  backgrounBaseLinear:
    'linear-gradient(198.31deg, rgba(132, 177, 216, 0.7) 1.55%, rgba(34, 56, 104, 0.7) 49.75%, rgba(132, 177, 216, 0.7) 100%), #186DB5',

  // Result image variables
  urlPositiveImage: 'chembio/positive_result.png',
  urlNegativeImage: 'chembio/negative_result.png',
  urlInvalidOneLineImage: 'chembio/invalid_one_line_result.png',
  urlInvalidNoLineImage: 'chembio/invalid_no_line_result.png',
  urlNegativeWithoutSymptomsImage: 'eco/eco-negative-without-symptons.png',
  heightNegativeWithoutSymptomsImage: '173px',
  widthNegativeWithoutSymptomsImage: '173px',
  urlNegativeWithSymptomsImage: 'eco/eco-negative-with-symptons.png',
  heightNegativeWithSymptomsImage: '124px',
  widthNegativeWithSymptomsImage: '122px',
  urlPositiveWithoutSymptomsImage: 'eco/eco-positive-without-symptons.png',
  heightPositiveWithoutSymptomsImage: '121px',
  widthPositiveWithoutSymptomsImage: '173px',
  urlPositiveWithSymptomsImage: 'eco/eco-positive-with-symptons.png',
  heightPositiveWithSymptomsImage: '124px',
  widthPositiveWithSymptomsImage: '150px',
};

export { ChembioHivThemeVariables };
